<template>
  <div>
    <mu-row gutter>
      <mu-col width="100" desktop="30" tablet="40">
        <mu-card @click.native="toggleFilterShowing">
          <mu-card-text>
            Refine filters
            <div style="float:right">
              <mu-icon v-show="refiningFilters === true" value="keyboard_arrow_up"></mu-icon>
              <mu-icon v-show="refiningFilters === false" value="keyboard_arrow_down"></mu-icon>
            </div>
          </mu-card-text>
        </mu-card>
        <div v-if="refiningFilters === true">
          <recipe-search :is-results-page="true" :fullWidth="true"
                         :filterData="filterData"
                         :categories="$store.state.recipes.categories" @filterModel="onFilterModelChange"
                         @recipeData="onRecipeSearchLoaded"
                         @isSearching="onSearchInitiated"
          ></recipe-search>
        </div>

      </mu-col>
      <mu-col width="100" desktop="70" tablet="60">
        <div style="text-align: center;height: 500px;display:flex;align-items: center;width: 100%;" v-if="isLoading">
          <div style="margin:0 auto">
            <mu-circular-progress></mu-circular-progress>
            <br/>
            {{ $t('message.loadingText') }}
          </div>
        </div>

        <div v-if="!isLoading && recipeData">
          <mu-row gutter>
            <mu-col class="bottom" v-for="(item, recipeI)  in recipeData.recipes" :key="'recipe-' + recipeI" width="100"
                    desktop="33" tablet="50">
              <div v-if="item">
                <recipe-card :recipe="item"></recipe-card>
              </div>
            </mu-col>
          </mu-row>

          <mu-pagination
            v-if="recipeData"
            :total="recipeData.paginationInfo.totalItems"
            :current="recipeData.paginationInfo.actualPage + 1"
            :defaultPageSize="15"
            :pageSize="15"
            @pageChange="handlePageChange">
          </mu-pagination>
        </div>
      </mu-col>

    </mu-row>


  </div>
</template>
<script>
import $ from 'jquery'
import axios from 'axios'
import {mapGetters} from 'vuex'
import RecipeCard from "./Components/RecipeCard";
import RecipeSearch from "./Search";

import RecipeFilterMixin from './Mixins/Filter'
import MuPagination from "muse-ui/src/pagination/pagination";
import MuCircularProgress from "muse-ui/src/circularProgress/circularProgress";
import RecipeApi from '../../api/Recipes'

export default {
  mixins: [RecipeFilterMixin],
  components: {
    MuCircularProgress,
    MuPagination,
    RecipeSearch,
    RecipeCard
  },
  name: "recipe-search-results",
  props: {
    data: null
  },
  watch: {
    'getRecipeSearchFilter': function (data) {
      this.filterModel = data;
    },
    '$route': {
      immediate: false,
      handler: function () {
        this.refiningFilters = false;
        this.checkWindowWidth();
        this.filterData = this.$route.params.filterData;
        this.$forceUpdate();
      }
    },
    'data': function () {
      if (this.data) {
        this.recipeData = this.data
      }
    }
  },
  data() {
    return {
      isLoading: true,
      refiningFilters: true,
      filterData: null,
      recipeData: {
        recipes: []
      },
      filterModel: {
        search: null
      }
    }
  },
  mounted() {
    let self = this;
    self.refiningFilters = false;
    self.filterData = self.$store.state.recipes.filterData;
    self.filterModel = self.$store.state.recipes.filterData;

    self.checkWindowWidth();

    if (self.filterModel === undefined) {
      let data = self.$store.state.recipes.filterData;
      self.filterData = data;
      if (data == null) {
        this.isLoading = false;

        let carbsGTE = self.getRecipeSearchFilter.carbs[0], carbsLTE = self.getRecipeSearchFilter.carbs[1];
        let fatGTE = self.getRecipeSearchFilter.fat[0], fatLTE = self.getRecipeSearchFilter.fat[1];
        let caloriesGTE = self.getRecipeSearchFilter.calories[0], caloriesLTE = self.getRecipeSearchFilter.calories[1];
        let proteinGTE = self.getRecipeSearchFilter.protein[0] !== undefined ? self.getRecipeSearchFilter.protein[0] : 0,
          proteinLTE = self.getRecipeSearchFilter.protein[1] !== undefined ? self.getRecipeSearchFilter.protein[1] : 500;

        let totaltimeGTE = self.getRecipeSearchFilter.totaltime[0];
        let totaltimeLTE = self.getRecipeSearchFilter.totaltime[1];


        let queryParams = {
          search: self.$route.query.search,
          page: self.$route.query.page,
          limit: 15,
          carblte: carbsLTE,
          carbgte: carbsGTE,
          fatlte: fatLTE,
          fatgte: fatGTE,
          totaltimelte: totaltimeLTE,
          totaltimegte: totaltimeGTE,
          caloriesgte: caloriesGTE,
          calorieslte: caloriesLTE,
          proteinlte: proteinLTE,
          proteingte: proteinGTE,
          suitabilities: self.getChecked('suitabilities').join(','),
          dietaryTypes: self.getChecked('dietaryTypes').join(','),
          cuisines: self.getChecked('cuisines').join(','),
          occasions: self.getChecked('occasions').join(','),
          categories: self.getChecked('categories').join(',')
        };

        RecipeApi.search(self.clearQueryParameters(queryParams))
          .then(function (response) {
            self.$nextTick(function () {
              self.isLoading = false;
              this.recipeData = res.data;
              self.$router.replace({
                name: 'RecipeSearchResults',
                query: self.clearQueryParameters(queryParams),
                params: {
                  data: response.data
                }
              });
            })
          })
      } else {
        let queryParams = {
          search: self.$route.query.search,
          page: self.$route.query.page,
          limit: 15
        }
        RecipeApi.search(self.clearQueryParameters(queryParams))
          .then(function (response) {
            self.$nextTick(function () {
              self.isLoading = false;
              self.recipeData = response.data;
            })
          });
      }
    } else {

      let carbsGTE = self.getRecipeSearchFilter.carbs[0], carbsLTE = self.getRecipeSearchFilter.carbs[1];
      let fatGTE = self.getRecipeSearchFilter.fat[0], fatLTE = self.getRecipeSearchFilter.fat[1];
      let caloriesGTE = self.getRecipeSearchFilter.calories[0], caloriesLTE = self.getRecipeSearchFilter.calories[1];
      let proteinGTE = self.getRecipeSearchFilter.protein[0] !== undefined ? self.getRecipeSearchFilter.protein[0] : 0,
        proteinLTE = self.getRecipeSearchFilter.protein[1] !== undefined ? self.getRecipeSearchFilter.protein[1] : 500;

      let totaltimeGTE = self.getRecipeSearchFilter.totaltime[0];
      let totaltimeLTE = self.getRecipeSearchFilter.totaltime[1];

      let queryParams = {
        search: self.$route.query.search,
        page: self.$route.query.page,
        limit: 10,
        carblte: carbsLTE,
        carbgte: carbsGTE,
        fatlte: fatLTE,
        fatgte: fatGTE,
        totaltimelte: totaltimeLTE,
        totaltimegte: totaltimeGTE,
        caloriesgte: caloriesGTE,
        calorieslte: caloriesLTE,
        proteinlte: proteinLTE,
        proteingte: proteinGTE,
        suitabilities: self.getChecked('suitabilities').join(','),
        dietaryTypes: self.getChecked('dietaryTypes').join(','),
        cuisines: self.getChecked('cuisines').join(','),
        occasions: self.getChecked('occasions').join(','),
        categories: self.getChecked('categories').join(',')
      };

      this.isLoading = false;
      this.recipeData = this.data;
      this.filterData = this.filterModel;

      self.isLoading = true;

      RecipeApi.search(self.clearQueryParameters(queryParams))
        .then(function (res) {
          self.$nextTick(function () {
            this.recipeData = res.data;
            self.isLoading = false;
            self.$router.replace({
              name: 'RecipeSearchResults',
              query: self.clearQueryParameters(queryParams),
              params: {
                data: res.data,
                filterModel: self.filterData
              }
            });
          })
        });
    }
  },
  methods: {
    onSearchInitiated() {
      this.isLoading = true;
    },
    onFilterModelChange(data) {
      this.filterModel = data;
    },
    onRecipeSearchLoaded(data) {
      if (data) {
        this.recipeData = data;
        this.isLoading = false;
      }
    },
    checkWindowWidth() {
      let self = this;
      let windowWidth = $('body').outerWidth();
      if (windowWidth > 1024) {
        self.$nextTick(function () {
          self.refiningFilters = true;
        })

      } else {
        self.refiningFilters = false;
      }
    },
    getChecked(key) {
      let self = this;
      let checkedItems = [];
      let checked = self.getRecipeSearchFilter[key].filter((item) => {
        return item.checked === true;
      });
      checked.forEach((item) => {
        checkedItems.push(item.label);
      });
      return checkedItems;
    },
    handlePageChange(page) {
      let self = this;
      let actualPage = page;


      let carbsGTE = 0;
      let carbsLTE = 0;

      let fatGTE = 0;
      let fatLTE = 0;

      let caloriesGTE = 0;
      let caloriesLTE = 0;

      let proteinGTE = 0;
      let proteinLTE = 0;


      if (_.has(self.filterModel, 'carbs')) {
        carbsGTE = self.filterModel.carbs[0], carbsLTE = self.filterModel.carbs[1];
      }

      if (_.has(self.filterModel, 'fat')) {
        fatGTE = self.filterModel.fat[0], fatLTE = self.filterModel.fat[1];
      }

      if (_.has(self.filterModel, 'calories')) {
        caloriesGTE = self.filterModel.calories[0], caloriesLTE = self.filterModel.calories[1];
      }

      if (_.has(self.filterModel, 'protein')) {
        proteinGTE = self.filterModel.protein[0], proteinLTE = self.filterModel.protein[1];
      }

      let totaltimeGTE = self.filterModel.totaltime[0];
      let totaltimeLTE = self.filterModel.totaltime[1];


      let queryParams = {
        search: self.$route.query.search ? self.$route.query.search : '',
        page: actualPage - 1,
        limit: 10,
        carblte: carbsLTE,
        carbgte: carbsGTE,
        fatlte: fatLTE,
        fatgte: fatGTE,
        caloriesgte: caloriesGTE,
        calorieslte: caloriesLTE,
        proteinlte: proteinLTE,
        proteingte: proteinGTE,
        totaltimelte: totaltimeLTE,
        totaltimegte: totaltimeGTE,
        suitabilities: self.getChecked('suitabilities').join(','),
        dietaryTypes: self.getChecked('dietaryTypes').join(','),
        cuisines: self.getChecked('cuisines').join(','),
        occasions: self.getChecked('occasions').join(','),
        categories: self.getChecked('categories').join(',')
      };

      self.isLoading = true;
      RecipeApi.search(self.clearQueryParameters(queryParams))
        .then(function (response) {
          if (_.has(self.$route.query, 'search')) {
            self.filterModel.search = self.$route.query.search;
          }

          self.$store.commit('setRecipeFilter', self.filterModel);
          self.$router.replace({
            name: 'RecipeSearchResults',
            query: self.clearQueryParameters(queryParams),
            params: {
              data: response.data,
              filterModel: self.filterModel
            }
          });
          self.isLoading = false;
        })
    },
    toggleFilterShowing() {
      this.refiningFilters = !this.refiningFilters;
    }
  },
  computed: {
    ...mapGetters(['getRecipeSearchFilter'])
  }
}
</script>



// WEBPACK FOOTER //
// Results.vue?64908179